import { render, staticRenderFns } from "./FloatIcon.vue?vue&type=template&id=1c802154&scoped=true&"
import script from "./FloatIcon.vue?vue&type=script&lang=js&"
export * from "./FloatIcon.vue?vue&type=script&lang=js&"
import style0 from "./FloatIcon.vue?vue&type=style&index=0&id=1c802154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c802154",
  null
  
)

component.options.__file = "FloatIcon.vue"
export default component.exports